import { render, staticRenderFns } from "./QuizzOutro.vue?vue&type=template&id=ec7b1c24&"
import script from "./QuizzOutro.vue?vue&type=script&lang=js&"
export * from "./QuizzOutro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports